module.exports = __webpack_public_path__ + "static/media/wfz.e37b70ca.mp4";